import React from 'react';

import IzendaIntegrate from '../../helper/IzendaIntegrate';
import {Indicator} from '../../components/indicators/indicator';

let interval = null;
let dom = null;

class IzendaSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true
    };
  }

  componentDidMount() {
    interval = setInterval(() => {
      if (window.IzendaSynergy) {
        dom = IzendaIntegrate.RenderIzendaSettings(this.hideLoading);
        clearInterval(interval);
      }
    }, 1000);
  }

  componentWillUnmount() {
    IzendaIntegrate.DestroyDom(dom);
  }

  hideLoading = () => {
    setTimeout(() => {
      this.setState({ isLoading: false });
      $('body').on('DOMSubtreeModified', '.izenda-SettingLevel .izenda-Dropdown-control', () => {
        if ($('.izenda-SettingLevel .izenda-Dropdown .izenda-Dropdown-control').attr('title') !== 'System') {

          $('.connection-string-validation-container input').css('pointer-events', 'none');
          $('.connection-string-validation-container .izenda-Dropdown .izenda-Dropdown-control').css('pointer-events', 'none');
          $('.connection-string-validation-container .connection-string-builder').css('pointer-events', 'none');
          $('.connection-string-validation-container button').prop('disabled', true);

          $('.connection-string-validation-container input').css('background-color', '#CCC');
          $('.connection-string-validation-container .izenda-Dropdown .izenda-Dropdown-control').css('background-color', '#CCC');
          $('.connection-string-validation-container .connection-string-builder span').css('color', '#CCC');
          $('.connection-string-validation-container .connection-string-builder i').css('color', '#CCC');

        } else {
          $('.connection-string-validation-container input').css('pointer-events', '');
          $('.connection-string-validation-container .izenda-Dropdown .izenda-Dropdown-control').css('pointer-events', '');
          $('.connection-string-validation-container .connection-string-builder').css('pointer-events', '');
          $('.connection-string-validation-container button').prop('disabled', false);

          $('.connection-string-validation-container input').css('background-color', '#FFF');
          $('.connection-string-validation-container .izenda-Dropdown .izenda-Dropdown-control').css('background-color', '#FFF');
          $('.connection-string-validation-container .connection-string-builder span').css('color', '#FFF');
          $('.connection-string-validation-container .connection-string-builder i').css('color', '#FFF');
        }
      });
    }, 1000);
  }

  render() {
    return <div>
      {
        this.state.isLoading && <Indicator id='setting-loading' show={true} />
      }
      <div className='page-title clearfix'>
        <h2 className='pull-left'>Settings</h2>
      </div>
      <div className='izenda-container' id='izenda-root-settings' style={{height: 1000}} />
    </div>;
  }
}

export default IzendaSettings;



// WEBPACK FOOTER //
// ./src/izenda/containers/settings.js